import type { Action } from 'redux'
import type { InvokeDefinition, StreamDefinition } from '../../../signalr/types'
import {
  defaultGetParams as getParams,
  payloadAsParam
} from '../../../signalr/helpers'
import { addToast } from '../../toasts/actions'
import type { ErrorMessageContents } from '../../../helpers/hub'
import {
  type SystemParamSaveAction,
  type SystemParamsDeleteAction,
  addSystemParam,
  systemParamFetchFail,
  saveSystemParamSuccess,
  saveSystemParamFailure,
  deleteSystemParamsSuccess,
  deleteSystemParamsFailure
} from './actions'
import type { SystemParam } from './types'

const errorToast = (action: string, err: ErrorMessageContents) =>
  addToast({
    message: err.message,
    options: { toastId: `sysparam-${action}-error`, type: 'error' }
  })

export const fetchSystemParamDefinition: StreamDefinition<
  [],
  SystemParam[],
  Action
> = {
  method: 'GetSystemParameters',
  strategy: 'switch',
  getParams,
  mapResponse: addSystemParam,
  mapError: systemParamFetchFail,
  cancelOn: ['sysparam.fetchCancel']
}

export const saveSystemParamDefinition: InvokeDefinition<
  [SystemParam],
  number,
  SystemParamSaveAction
> = {
  method: 'SaveSystemParam',
  getParams: payloadAsParam,
  mapResponse: (transactionId, action) =>
    saveSystemParamSuccess(action.payload, transactionId),
  mapError: (err) => [saveSystemParamFailure(err), errorToast('save', err)]
}

export const deleteSystemParamsDefinition: InvokeDefinition<
  [SystemParam[]],
  string,
  SystemParamsDeleteAction
> = {
  method: 'DeleteSystemParams',
  getParams: payloadAsParam,
  mapResponse: (_, action) => deleteSystemParamsSuccess(action.payload),
  mapError: (err) => [deleteSystemParamsFailure(err), errorToast('delete', err)]
}
